<template>
  <section class="parts-item-card-body">
    <section class="parts-item-card-body__main">
      <section class="parts-item-card-body__main__left">
        <section class="parts-item-card-body__main__actions">
          <PCPartsItemCardBodyMainActions
            v-if="workPart"
            :work-part="workPart"
          />
        </section>

        <section class="parts-item-card-body__main__info">
          <div class="parts-item-card-body__main__info__name">
            {{ workPart.NombreArticulo }}
          </div>

          <div
            v-if="!isPartFinished && workPart.NumeroSerie"
            class="parts-item-card-body__main__info__serial-number"
          >
            {{ workPart.NumeroSerie }}
          </div>
        </section>
      </section>

      <section class="parts-item-card-body__main__right">
        <f7-button
          type="button"
          title="Más opciones"
          @click="isSecondaryActionsOpened = true"
        >
          <UCSvgIcon
            name="ic_options"
            width="32px"
            height="32px"
          />
        </f7-button>
      </section>
    </section>

    <section
      v-if="isUserResponsible || shouldShowAddress || workPart.ObservacionesOrden"
      class="parts-item-card-body__secondary"
    >
      <div v-if="isUserResponsible">
        <UCSvgIcon
          name="fa6-solid-user"
          height="16px"
        />
        <span>Responsable del parte</span>
      </div>

      <div v-if="shouldShowAddress">
        <UCSvgIcon
          name="fa6-solid-location-arrow"
          height="16px"
        />
        <span>{{ workPart.DireccionClienteCompleta }}</span>
      </div>

      <div v-if="workPart.ObservacionesOrden">
        <UCSvgIcon
          name="fa6-solid-comment"
          height="16px"
        />
        <span>{{ workPart.ObservacionesOrden }}</span>
      </div>
    </section>

    <PCPartsItemCardBodySecondaryActions
      v-if="workPart"
      v-model:opened="isSecondaryActionsOpened"
      :work-part="workPart"
    />
  </section>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useRepairParts } from '@/composables/useRepairParts';

import UCSvgIcon from '@/components/common/UCSvgIcon.vue';
import PCPartsItemCardBodyMainActions from './PCPartsItemCardBodyMainActions.vue';
import PCPartsItemCardBodySecondaryActions from './PCPartsItemCardBodySecondaryActions.vue';

/** @import { PropType } from 'vue' */
/** @import { WorkPartItem } from '@/js/stores/repairParts' */

const props = defineProps({
  workPart: {
    /** @type {PropType<WorkPartItem>} */
    type: Object,
    default: null,
  },
});

const isSecondaryActionsOpened = ref(false);

const { isUserResponsibleWorkPart } = useRepairParts();

const isUserResponsible = computed(() => isUserResponsibleWorkPart(props.workPart.Id_TrabajadorPropietario));

const isPartFinished = computed(() => props.workPart.FechaFinalizacionOrden !== null);
const shouldShowAddress = computed(() => !isPartFinished.value && !!props.workPart.DireccionClienteCompleta);
</script>

<style scoped lang="scss">
.parts-item-card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__main {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &__left {
      display: flex;
      flex-direction: row;
      width: 100%;
      gap: 4px;
    }

    &__actions {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: center;
      min-width: min(100%, 64px);

      :deep(.button) {
        padding: 4px;
      }
    }

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: center;

      &__name {
        color: #172b4d;
        font-weight: bold;
      }

      &__serial-number {
        color: var(--his-lighgray);
        font-size: smaller;
      }
    }
  }

  &__secondary {
    font-size: smaller;
    color: #6f6f6f;

    > div {
      display: flex;
      align-items: center;

      svg {
        padding-right: 4px;
      }
    }
  }
}
</style>
